// extracted by mini-css-extract-plugin
module.exports = {"promo-label":"_6f25b66c20--promo-label--1qqnK"};